import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import userManager from "../helpers/UserManager";
import strings from "../helpers/Localization";
import getReleaseNotesEN from "./ReleaseNote/releaseNoteEN";

//MUI ELEMENTS
import {
    Paper,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Toolbar,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Stack,
    AppBar

} from "@mui/material";

//MUI ICONS
import AddCircle from "@mui/icons-material/AddCircle";
import CheckIcon from "@mui/icons-material/Check";
import Loader from "../aGlobalDesign/Loader/Loader";
import Avatar from "../aGlobalDesign/Avatar/Avatar";
import PageMetaHelmet from "../aGlobalDesign/PageMetaHelmet/PageMetaHelmet";

class Login extends React.Component {

    constructor() {
        super();
        this.state = {
            isLoging: false,

            // releaseNoteDialog: null,
            // currentReleaseEN: getReleaseNotesEN()[0],

            isActiveToday: true,
            reportingData: null

        };
    }

    componentDidMount() {
        this.props.closeAllMenus();
        this.props.changeAppBarTitle(strings.home);
        this.props.ChangeCurrentMenuName(strings.dashboard);
        if (!this.props.currentuser.user && !this.state.isLoging) {
            this.onSubmit();
        }
        if (this.props.currentuser.user && this.props.currentuser.user.invitations && this.props.currentuser.user.invitations.length === 1) {
            this.onSelectInvitation(this.props.currentuser.user.invitations[0]);
        }
    }

    onSubmit() {
        this.setState({ isLoging: true });
        if (this.props.location && this.props.location.state && this.props.location.state.from) {
            userManager.signinRedirect({ data: this.props.location.state.from });
        }
        else {
            userManager.signinRedirect();
        }
    }

    onSelectOrganization(organization) {
        this.props.GetOrganization(organization);
    }
    onSelectInvitation(invitation) {
        this.props.AcceptInvitation(invitation);
    }

    handleClickRefresh() {
        this.onFetchReporting();
    }

    render() {
        const orgId = this.props.currentuser && this.props.currentuser.currentorganization ? this.props.currentuser.currentorganization.id : null;
        const orgUser = orgId && this.props.currentuser.user && this.props.currentuser.user.organizationUsers ? this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId) : null;
        const userAvatar = orgUser && orgUser.avatar ? JSON.parse(orgUser.avatar).PhotoThumbnailURL : null;
        const currentOrganisationUser = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.currentorganization && this.props.currentuser.user.organizationUsers.find(ou => ou.organizationId === this.props.currentuser.currentorganization.id);
        return <div className="defaultPageContent">
            <PageMetaHelmet title={strings.helmetLogin} icon={"/icons/favicon.ico"} />
            {
                this.props.currentuser.user ?
                    <>
                        {
                            this.props.currentuser.user.invitations.length > 0 ?
                                <Paper style={{ width: 400, margin: "auto", marginTop: 20 }}>
                                    <List>
                                        <Typography className="noselect" variant="h6" style={{ textAlign: "center" }}>
                                            {strings.organizations}
                                        </Typography>
                                        {
                                            this.props.currentuser.user.invitations.map((invitation) => {
                                                if (!invitation) {return null;}
                                                if (this.props.currentuser.user.invitations.length === 1) {
                                                    return <ListItem key={invitation.id}>
                                                        <ListItemText
                                                            primary={invitation.organization.name}
                                                            secondary={"veuillez patienter, nous vous incrivons à votre organisation..."}
                                                        >
                                                        </ListItemText>
                                                    </ListItem>;
                                                }
                                                return <ListItem key={invitation.id} button
                                                    onClick={() => this.onSelectInvitation(invitation)}>
                                                    <ListItemText
                                                        primary={invitation.organization.name}
                                                        secondary={invitation.message ? invitation.message.slice(0, 47) + (invitation.message.length > 47 ? "..." : "") : null}
                                                    >
                                                    </ListItemText>
                                                    <ListItemIcon>
                                                        <AddCircle/>
                                                    </ListItemIcon>
                                                </ListItem>;
                                            })
                                        }
                                        {
                                            this.props.currentuser.user.organizationUsers ?
                                                this.props.currentuser.user.organizationUsers.map((organizationUser) => {
                                                    return <ListItem key={organizationUser.organizationId} button
                                                        onClick={() => this.onSelectOrganization(organizationUser.organization)}
                                                    >
                                                        <ListItemText primary={organizationUser.organization.name}></ListItemText>
                                                    </ListItem>;
                                                }) : null
                                        }
                                    </List>
                                </Paper>
                                : this.props.currentuser.currentorganization || this.props.currentuser.user.connectionStatus ?
                                    <div className="welcome-container">
                                        <div className="welcome-image">
                                            <img src="images/skalink-symbol.svg"/>
                                            <div className="welcome-avatar">
                                                <Avatar
                                                    href={userAvatar}
                                                    heightAvatar="42px"
                                                    widthAvatar="42px"
                                                />
                                            </div>
                                        </div>
                                        <p className="welcome-message">Bienvenue, {currentOrganisationUser ? currentOrganisationUser.displayName : ""} !</p>
                                    </div>
                                    : //if user exist and has no organization / invitation
                                    <Typography className="noselect" sx={{ ml: 2, mt: 1, flex: 1 }} noWrap >
                                        {strings.noOrganisation}
                                    </Typography>
                        }
                    </> :
                    //if user is not logged in
                    <div className="defaultPageContent">
                        <div className="defaultPageWrapper">
                            <Stack alignItems="center" justifyContent="Center" style={{ height: "100%" }}>
                                <div style={{ textAlign: "center", marginTop: "70px" }}>
                                    <Loader dimensions="40px" color={"var(--primary-base)"} />
                                </div>
                                <span style={{ height: "200px" }}/>
                            </Stack>
                        </div>
                    </div>
            }
        </div>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(Login));
